import { View, Modal, Text, ActivityIndicator } from "react-native";
import React from "react";
import colors from "@constants/color";

const ProcessingModal = ({ showProcessingModal }) => {
  return (
    <Modal
      statusBarTranslucent
      navigationBarTranslucent
      visible={showProcessingModal}
      transparent
      animationType="fade"
    >
      <View
        style={{
          flex: 1,
          backgroundColor: "rgba(255,255,255,0.9)",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <ActivityIndicator size="large" color={colors.primary} />
        <Text style={{ fontSize: 20, marginTop: 20 }}>
          कृपया प्रतीक्षा करें
        </Text>
      </View>
    </Modal>
  );
};

export default ProcessingModal;
